module.exports = {
  APILOCALURL: "http://localhost:5041/api/",
  APISERVERURL: "http://localhost:5041/api/",
  APIACTIVEURL: "https://munnysalon.azurewebsites.net/api/",
  
  

  REGISTER: "auth/register",
  LOGIN: "auth/login",
  FORGOTPASSWORD: "auth/forgotpassword",
  RESETPASSWORD: "auth/resetpassword",
  CHANGEPASSWORD: "auth/ChangePassword",

  GETUSERPROFILE:"users/profile",
  UPDATEUSERPROFILE:"users/profile",
   
  CREATESALON: "salon",
  UPDATESALON: "salon",
  GETALLSALON: "salon/getall",
  GETSALONS: "salon/get",
  GETSALONSBYID:"salon",
  DELETESALON: "salon",
  



  GETCUSTOMER: "customer/getall",
  GETALLCUSTOMER: "customer/getall",
  CREATECUSTOMER: "customer",
  UPDATECUSTOMER: "customer",
  DELETECUSTOMER: "customer",


   GETALLSTAFF: "staff/getall",
  CREATESTAFF: "staff",
  UPDATESTAFF: "staff",
  DELETESTAFF: "staff",
  GETALLSALON: "salon/getall",
  GETSTAFFBYSALONID: "staff/getstaffbysalonid",


    GETALLCATEGORIES: "category/getall",
    CREATECATEGORY: "Category",
    DELETECATEGORY: "Category",
    UPDATECATEGORY: "Category",


    GETSERVICETYPE: "ServiceType/getall",
    CREATESERVICETYPE: "ServiceType",
    UPDATESERVICETYPE: "ServiceType",
    DELETESERVICETYPE: "ServiceType",
    GetServiceTypesBySalonId: "ServiceType/getbysalonid",
    GETALLCATEGORIES: "Category/getall",


 GETALLTIMINGS: "SalonTiming/GetAll",
  GETTIMINGBYSALONID: "SalonTiming/GetBySalon/", 
  CREATETIMING: "SalonTiming",
  UPDATETIMING: "SalonTiming",
  DELETETIMING: "SalonTiming",



  // ===== BRAND APIs =====
GETALLBRANDS: "Brand/GetAll",
CREATEBRAND: "Brand",
UPDATEBRAND: "Brand",
DELETEBRAND: "Brand",

GETALLPRODUCTS: "Product/GetAll",
GETPRODUCTBYID: "Product",
CREATEPRODUCT: "Product",
UPDATEPRODUCT: "Product",
DELETEPRODUCT: "Product",



GETALLPRODUCTIMAGES: "ProductImage/GetAll",
GETPRODUCTIMAGES: "ProductImage",
CREATEPRODUCTIMAGE: "ProductImage",
UPDATEPRODUCTIMAGE: "ProductImage",
DELETEPRODUCTIMAGE: "ProductImage",


CREATECUSTOMER: 'customer',




APPOINTMENTS: "Appointments",   

 
 DELETEAPPOINTMENT: "Appointments",

 GETALLAPPOINTMENTS: "appointments/GetAll",
  GETAPPOINTMENTSBYUSERID: "appointments/user",
  GETAPPOINTMENTSBYSALONID: "appointments/salon",
CREATEAPPPOINTMENT: "appointments",
UPDATEAPPPOINTMENT:"appointments",
CANCELAPPPOINTMENT :"appointments/cancel" ,


  // Add these to your existing config object
GETALLORDERS: "Orders/GetAll",
GETOERDERSBYUSERID: "Orders/User",
CREATEORDER: "Orders",
UPDATEORDERSTATUS: "Orders/UpdateStatus",
}